<template>
    <div>
        <v-form v-show="action==='pwchange'" ref="pwform" @submit.prevent="changePassword" v-model="passwordFormValid"
                lazy-validation>
            <card-form title="Change initial password" action="Change" :valid="passwordFormValid" :loading="loading"
                       :error="fromError">
                Password must contain at least eight characters, including uppercase and lowercase letters and numbers.
                <v-text-field :disabled="loading" id="newpassword" prepend-icon="lock" append-icon="visibility"
                              @click:append="togglePassword" name="newpassword" label="Password" autocomplete="nope"
                              :type="passwordType" required v-model="newPassword"
                              :rules="newPasswordRules"></v-text-field>
            </card-form>
        </v-form>
        <v-form v-show="action==='signin'" ref="signinform" @submit.prevent="signIn" v-model="signInFromValid"
                lazy-validation>
            <card-form title="CARU Login" action="Anmelden" :valid="signInFromValid" :loading="loading" :error="fromError">
                <v-text-field :disabled="loading" prepend-icon="person" name="username" label="Benutzername" v-model="username"
                              type="text" required :rules="usernameRules"></v-text-field>
                <v-text-field :disabled="loading" id="password" prepend-icon="lock"
                              name="password" label="Passwort"
                              type="password" required v-model="password" :rules="passwordRules"></v-text-field>
            </card-form>
        </v-form>
    </div>
</template>

<script>
import { ConsoleLogger as Logger } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import CardForm from './CardForm'

const logger = new Logger('SignInComp')

export default {
  name: 'SignIn',
  components: {CardForm},
  data () {
    return {
      action: 'signin',
      loading: false,
      fromError: null,
      passwordType: 'password',
      user: null,
      signInFromValid: false,
      passwordFormValid: false,
      username: '',
      usernameRules: [
        v => !!v || 'Benutzername ist erforderlich',
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Passwort ist erforderlich'
      ],
      newPassword: '',
      newPasswordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Minimum 8 Zeichen',
        v => /(?=.*[A-Z])/.test(v) || 'Ein Grossbuchstabe ist erforderlich',
        v => /(?=.*[a-z])/.test(v) || 'Ein Kleinbuchstabe ist erforderlich',
        v => /(?=.*[0-9])/.test(v) || 'Eine Zahl ist erforderlich'
      ]
    }
  },
  methods: {
    togglePassword: function () {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    changePassword: async function () {
      this.fromError = null
      if (this.$refs.pwform.validate()) {
        this.loading = true
        try {
          let user = await Auth.completeNewPassword(this.user, this.newPassword, {name: 'Caru Demo User'})
          this.$store.commit('auth/setUser', user)
          Object.assign(this.$vuetify.theme, this.$store.state.tenant.config.theme)
          this.$router.push({name: 'dashboard'})
        } catch (e) {
          logger.error(e)
          this.fromError = 'Invalid password.'
          this.loading = false
        }
      }
    },
    signIn: async function () {
      this.fromError = null
      if (this.$refs.signinform.validate()) {
        this.loading = true
        // Get tenant config
        try {
          let cfg = await this.$store.dispatch('tenant/fetchUserConfig', this.username)
          this.$store.commit('tenant/setConfig', cfg)
          this.$store.dispatch('tenant/configureAmplify')

          this.user = await Auth.signIn(this.username, this.password)
          this.loading = false

          // Store config after successful sign-in
          this.$store.dispatch('tenant/storeConfig')

          // Check if user has to set a new password
          if (this.user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.action = 'pwchange'
          } else {
            // Load theme
            Object.assign(this.$vuetify.theme, this.$store.state.tenant.config.theme)
            this.$store.commit('auth/setUser', this.user)
            this.$router.push({name: 'dashboard'})
          }

        } catch (e) {
          logger.error(e)
          this.fromError = 'Ungültiger Benutzername oder Passwort.'
          this.loading = false
        }
      }
    }
  }
}
</script>
